module.exports = __webpack_public_path__ + "e3a5073cc222f618a634718230e20485.jpg";